import React, { Component } from "react";
import { withAppState } from "../../state";
import {
  EpgCategoryContainer,
  ChannelImageContainer,
  ImageStyled,
  IconStyled,
  IconOverlayStyled,
  ProgramListContainer,
  ProgramItemsStyled,
  ProgramSlotStyled,
  ProgramSlotClick,
  BackgroundImageStyled,
  EpgEventsContainer,
  ChannelRowContainer,
  ProgramInnerContainer,
  ProgramTitleStyled,
  StatusWrapper,
  ProgramDurationStyled,
  ProgramDurationGradientBarWrapper,
  ProgressStyled,
  ProgramSlot
} from "./viewStyles/Styled";
import { ArrowsContainer, LayoutLeftArrow, LayoutRightArrow } from "./styles/Styled";
import { AirRemoteArrows } from "../../services/visualLibraryService";
import EpgCategoriesHeader from "../../components/EPG/EpgCategories/EpgCategoriesHeader";
import { Image } from "../../services/visualLibraryService";
import {
  EVENT_STATUS,
  debounce,
  getStatusTagText,
  calculateDurationForSlots,
  IMAGE_TYPES,
  getCurrentChannelImage,
  getProgress,
  getRemainingTime,
  doNothing
} from "../../utils/epgUtil";
import { onRight, onLeft, onUp, onDown } from "../../utils/epgNavigation";
import { directions, i18n } from "../../services/i18nService";
import { epgGridName } from "./Live";

const FOCUS_CLASS = "focused";
const SELECTED_CLASS = "selected";
const PREFIX_CATEGORY = "secondaryItem";
const POSTFIX_BUTTONS = "passThru";
const MAIN_MENU = "mainMenu";
const SCROLL_DELAY = 50;
class StaticEpg extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      rowIndex: 0,
      currentRowIndex: 0,
      colIndex: 0,
      categoryIndex: 0,
      isArrowLeftClicked: false,
      isArrowRightClicked: false
    };
    this.showRows = {
      from: 0,
      to: 3
    };
    this.showCat = {
      from: 0,
      to: 2
    };
    this.clearRefreshTimeout = null;
    this.staticViewNavigate = this.staticViewNavigate.bind(this);
    this.arrowUp = this.arrowUp.bind(this);
    this.arrowDown = this.arrowDown.bind(this);
    this.scrollUpDown = this.scrollUpDown.bind(this);
    this.onMouse = this.onMouse.bind(this);
    this.arrowLeft = this.arrowLeft.bind(this);
    this.arrowRight = this.arrowRight.bind(this);
    this.staticViewNavigate = debounce(this.staticViewNavigate, 1);
    // this.leftRightArrows = this.leftRightArrows.bind(this);
  }

  async componentDidMount() {
    this.props.changeView ? this.updateIndexState() : this.resetIndexState();
    document.addEventListener("keydown", this.staticViewNavigate, false);
  }

  componentWillUnmount() {
    if (this.clearRefreshTimeout) {
      clearTimeout(this.clearRefreshTimeout);
    }
    this.clearRefreshTimeout = null;

    document.removeEventListener("keydown", this.staticViewNavigate, false);
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevProps.staticData !== this.props.staticData) {
      this.resetIndexState();
    }
  }
  updateIndexState() {
    this.setState(
      {
        rowIndex: this.props.changeViewRowIndex,
        currentRowIndex: this.props.currentRowIndex,
        colIndex: 0,
        categoryIndex: this.props.categoryIndex
      },
      () =>
        this.props.onChange({
          rowIndex: this.state.rowIndex,
          colIndex: this.state.colIndex,
          categoryIndex: this.state.categoryIndex,
          changeView: false,
          showRows: this.showRows,
          showCat: this.showCat
        })
    );
    this.showRows = this.props.visibleRows;
    this.showCat = this.props.visibleCat;
  }

  resetIndexState() {
    this.showRows = {
      from: 0,
      to: 3
    };
    this.showCat = {
      from: 0,
      to: 2
    };
    this.setState(
      {
        rowIndex: 0,
        currentRowIndex: 0,
        colIndex: 0,
        categoryIndex: 0
      },
      () =>
        this.props.onChange({
          rowIndex: this.state.rowIndex,
          colIndex: this.state.colIndex,
          categoryIndex: this.state.categoryIndex,
          changeView: false,
          showRows: this.showRows,
          showCat: this.showCat
        })
    );
  }

  staticViewNavigate = async event => {
    if (
      this.props.applicationState.currentFocus.split("_")[0] === PREFIX_CATEGORY ||
      this.props.applicationState.currentFocus.split("_")[1] === POSTFIX_BUTTONS ||
      this.props.applicationState.currentFocus === MAIN_MENU ||
      this.props.isFullScreen === true
    ) {
      return;
    }
    this.props.onUpdateWheelState("idle");
    this.setState({ isArrowLeftClicked: false });
    this.setState({ isArrowRightClicked: false });
    let currentRowLength = this.props.staticData[this.state.categoryIndex]?.data[this.state.rowIndex]?.events?.length;
    let totalRows = this.props.staticData[this.state.categoryIndex]?.data.length;
    let totalCat = this.props.staticData?.length;
    let perviousCatTotalRows =
      totalCat > 1 && this.state.categoryIndex > 0
        ? this.props.staticData[this.state.categoryIndex - 1]?.data.length
        : this.props.staticData[this.state.categoryIndex]?.data.length;
    if (i18n.getDirection() === directions.RIGHT_TO_LEFT) {
      event.keyCode === 37 && onRight.call(this, currentRowLength);
      event.keyCode === 39 && onLeft.call(this, currentRowLength);
    } else {
      event.keyCode === 37 && onLeft.call(this, currentRowLength);
      event.keyCode === 39 && onRight.call(this, currentRowLength);
    }
    if (totalRows >= 1) {
      event.keyCode === 38 && onUp.call(this, totalRows, totalCat, perviousCatTotalRows);
      event.keyCode === 40 && onDown.call(this, totalRows, totalCat);
    }
  };

  async scrollUpDown(event) {
    if (this.props.applicationState.currentFocus !== epgGridName) {
      this.props.actions.setFocus(epgGridName);
    }
    this.props.onUpdateWheelState("active");
    if (event.deltaY > 0) {
      await this.reloadWait(SCROLL_DELAY);
      this.arrowDown();
    } else if (event.deltaY < 0) {
      await this.reloadWait(SCROLL_DELAY);
      this.arrowUp();
    }
  }
  reloadWait(ms) {
    return new Promise(resolve => (this.clearRefreshTimeout = setTimeout(resolve, ms)));
  }
  arrowUp() {
    let totalRows = this.props.staticData[this.state.categoryIndex]?.data.length;
    let totalCat = this.props.staticData?.length;
    let perviousCatTotalRows =
      totalCat > 1 && this.state.categoryIndex > 0
        ? this.props.staticData[this.state.categoryIndex - 1]?.data.length
        : this.props.staticData[this.state.categoryIndex]?.data.length;
    onUp.call(this, totalRows, totalCat, perviousCatTotalRows);
  }
  arrowDown() {
    let totalRows = this.props.staticData[this.state.categoryIndex]?.data.length;
    let totalCat = this.props.staticData?.length;
    onDown.call(this, totalRows, totalCat);
  }
  getCurrentRowLength() {
    return this.props.staticData[this.state.categoryIndex]?.data[this.state.rowIndex]?.events?.length;
  }
  arrowLeft(event) {
    event.stopPropagation();
    let rowLength = this.getCurrentRowLength();
    this.setState({ isArrowLeftClicked: true });
    this.setState({ isArrowRightClicked: false });
    if (i18n.getDirection() === directions.RIGHT_TO_LEFT) {
      onRight.call(this, rowLength);
    } else {
      onLeft.call(this, rowLength);
    }
  }
  arrowRight(event) {
    event.stopPropagation();
    let rowLength = this.getCurrentRowLength();
    this.setState({ isArrowRightClicked: true });
    this.setState({ isArrowLeftClicked: false });
    if (i18n.getDirection() === directions.RIGHT_TO_LEFT) {
      onLeft.call(this, rowLength);
    } else {
      onRight.call(this, rowLength);
    }
  }
  async onMouse(isLeftArrow, isRightArrow) {
    this.setState({ isArrowLeftClicked: isLeftArrow });
    this.setState({ isArrowRightClicked: isRightArrow });
  }
  leftRightArrows() {
    const LeftRightArrowStyles = {
      display: this.props.wheelState === "active" ? "block" : "none"
    };
    const { isArrowLeftClicked, isArrowRightClicked } = this.state;
    return (
      <ArrowsContainer>
        <LayoutLeftArrow
          onClick={e => {
            this.arrowLeft(e);
          }}
          onMouseEnter={() => this.onMouse(true, false)}
          onMouseLeave={() => this.onMouse(false, false)}
          style={LeftRightArrowStyles}
        >
          <AirRemoteArrows
            arrowDirection={i18n.getDirection() === directions.RIGHT_TO_LEFT ? "right" : "left"}
            isHover={isArrowLeftClicked}
          ></AirRemoteArrows>
        </LayoutLeftArrow>
        <LayoutRightArrow
          onClick={e => {
            this.arrowRight(e);
          }}
          onMouseEnter={() => this.onMouse(false, true)}
          onMouseLeave={() => this.onMouse(false, false)}
          style={LeftRightArrowStyles}
        >
          <AirRemoteArrows
            arrowDirection={i18n.getDirection() === directions.RIGHT_TO_LEFT ? "left" : "right"}
            isHover={isArrowRightClicked}
          ></AirRemoteArrows>
        </LayoutRightArrow>
      </ArrowsContainer>
    );
  }
  render() {
    const { currentVideoMetaData, applicationState, staticData, onClickEpgSlots } = this.props;
    const { currentRowIndex, colIndex } = this.state;
    return (
      <div
        onWheel={e => {
          this.scrollUpDown(e);
        }}
      >
        {this.leftRightArrows()}
        <EpgCategoryContainer>
          {staticData.slice(this.showCat.from, this.showCat.to).map((categoryData, index) => (
            <div key={`EpgCategoryContainer-${index}`}>
              <EpgCategoriesHeader heading={categoryData.heading} />
              <EpgEventsContainer>
                {categoryData.data.length > 0 &&
                  categoryData.data.slice(this.showRows.from, this.showRows.to).map((channelData, channelIndex) => {
                    const isOnCurrentRow =
                      applicationState.currentFocus === epgGridName && currentRowIndex === channelIndex && index === 0;
                    const hasSelectedProgram =
                      currentVideoMetaData && channelData.events?.some(event => event.id === currentVideoMetaData.id);
                    return (
                      <ChannelRowContainer key={`ChannelRowContainer-${channelIndex}`}>
                        <ChannelImageContainer>
                          <BackgroundImageStyled isSelected={hasSelectedProgram}>
                            {!channelData.isUserSubscribedToChannel && (
                              <IconStyled name="lock">
                                <IconOverlayStyled name="lock" />
                              </IconStyled>
                            )}
                            <ImageStyled
                              className={
                                colIndex === -1 && index === 0 && currentRowIndex === channelIndex && FOCUS_CLASS
                              }
                            >
                              <Image
                                url={
                                  isOnCurrentRow
                                    ? getCurrentChannelImage(channelData, IMAGE_TYPES.logoPng)
                                    : getCurrentChannelImage(channelData, IMAGE_TYPES.darkLogoPng)
                                }
                                alt={channelData.title}
                              />
                            </ImageStyled>
                          </BackgroundImageStyled>
                        </ChannelImageContainer>
                        <ProgramListContainer direction={i18n.getDirection()}>
                          <ProgramItemsStyled direction={i18n.getDirection()} view={"static"}>
                            {channelData.events?.map((event, eventIndex) => {
                              const isFocused =
                                applicationState.currentFocus === epgGridName &&
                                colIndex === eventIndex &&
                                this.props.backToCetaogryColIndex !== -1 &&
                                currentRowIndex === channelIndex &&
                                index === 0;
                              const isSelected = currentVideoMetaData && event.id === currentVideoMetaData.id;

                              return (
                                <ProgramSlot>
                                  <ProgramSlotStyled
                                    key={`ProgramSlotStyled-${eventIndex}`}
                                    className={`${isFocused && FOCUS_CLASS} ${isSelected && SELECTED_CLASS}`}
                                  >
                                    <ProgramSlotClick onClick={isFocused ? onClickEpgSlots : doNothing()}>
                                      <ProgramInnerContainer>
                                        <ProgramTitleStyled direction={i18n.getDirection()}>
                                          {event.title}
                                        </ProgramTitleStyled>
                                        <>
                                          {event.status === EVENT_STATUS.live ? (
                                            <ProgramDurationGradientBarWrapper>
                                              <ProgramDurationStyled direction={i18n.getDirection()}>
                                                {i18n.get(`pages.livePage.time.threeleft`, getRemainingTime(event))}
                                              </ProgramDurationStyled>
                                              <ProgressStyled
                                                playback={getProgress(event.tsStart, event.tsEnd)}
                                                height="0.22rem"
                                                isFromEPG={true}
                                                isSelected={isSelected}
                                              />
                                            </ProgramDurationGradientBarWrapper>
                                          ) : (
                                            <ProgramDurationStyled direction={i18n.getDirection()}>
                                              {calculateDurationForSlots(event.tsStart, event.tsEnd)}
                                            </ProgramDurationStyled>
                                          )}
                                        </>
                                        {isOnCurrentRow && (
                                          <StatusWrapper
                                            status={getStatusTagText(event.status, channelData.type)}
                                            direction={i18n.getDirection()}
                                          >
                                            {i18n.get(
                                              `pages.livePage.tags.${getStatusTagText(event.status, channelData.type)}`
                                            )}
                                          </StatusWrapper>
                                        )}
                                      </ProgramInnerContainer>
                                    </ProgramSlotClick>
                                  </ProgramSlotStyled>
                                </ProgramSlot>
                              );
                            })}
                          </ProgramItemsStyled>
                        </ProgramListContainer>
                      </ChannelRowContainer>
                    );
                  })}
              </EpgEventsContainer>
            </div>
          ))}
        </EpgCategoryContainer>
      </div>
    );
  }
}
export default withAppState(StaticEpg);
